<!--
 * @Author: xiehangyi
 * @LastEditors: 黄昱森
 * @Description:
-->
<template>
  <div :class="['lc-block', columnCls]" :style="customStyles">
    <slot />
  </div>
</template>

<script>
export default {
  name: 'LcBlock',
  props: {
    columns: {
      type: Number,
      default: 1
    },
    interval: {
      type: String,
      default: '20px'
    }
  },
  data() {
    return {};
  },
  computed: {
    columnCls() {
      return this.columns > 1 ? 'lc-block__columns' : ''
    },
    customStyles() {
      return {
        '--block-interval': this.interval,
      };
    },
  },
  created() {
    // preset
  },
  mounted() {
    // preset
  },
  methods: {}
};
</script>
